var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.events.length)?_c('b-card',{attrs:{"header-tag":"header","header-bg-variant":"dark","header-text-variant":"white","no-body":""}},[_c('EventsTable',{attrs:{"events":_vm.events,"title":_vm.title}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }